























import Vue from "vue";
import ItemAdminLinks from "@/components/ItemAdminLinks.vue";
import { CONTENT_URL } from '@/constants';

const COMICS_URL = `${CONTENT_URL}/comics`;

export default Vue.extend({
    components: {
        ItemAdminLinks,
    },

    props: {
        item: {
            type: Object,
            default: null
        },
    },

    computed: {
        comicMode(): boolean { return this.$store.state.items.length === 1 && this.$store.state.comicMode; },
        forwardUrl(): string { return this.$store.state.forwardUrl; },
        backUrl(): string { return this.$store.state.backUrl; },
    },

    mounted() {
        document.addEventListener('keyup', this.keyUp);
    },

    beforeDestroy() {
        document.removeEventListener('keyup', this.keyUp);
    },

    data() {
        return {
            showingText: false,
            showingComments: false,
            COMICS_URL,
        };
    },

    methods: {
        keyUp(e: KeyboardEvent): void {
            if (this.comicMode) {
                switch (e.code) {
                case "ArrowLeft":
                    this.$router.push({ path: this.backUrl });
                    break;
                case "ArrowRight":
                    this.$router.push({ path: this.forwardUrl });
                    break;
                }
            }
        },

        toggleComicMode(): void {
            this.$store.commit('toggleComicMode');
        },
    },

});
